/**
 * PageHeader — one page title pattern (title, context, metadata, actions).
 *
 * It only standardises the header block: information architecture and routing
 * are untouched in this phase (they belong to Phase 3).
 */
export function PageHeader({
  title,
  subtitle,
  meta,
  primaryAction,
  secondaryActions,
  className = "",
  testId = "page-header",
  children,
}) {
  return (
    <header
      data-testid={testId}
      className={`flex flex-wrap items-start justify-between gap-4 ${className}`}
    >
      <div className="min-w-0">
        <h1 className="text-2xl sm:text-3xl font-semibold text-content tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm md:text-base text-content-muted mt-2 max-w-2xl">{subtitle}</p>
        )}
        {meta && (
          <div
            data-testid={`${testId}-meta`}
            className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 text-label text-content-muted"
          >
            {meta}
          </div>
        )}
      </div>
      {(primaryAction || secondaryActions) && (
        <div className="flex flex-wrap items-center gap-2 shrink-0">
          {secondaryActions}
          {primaryAction}
        </div>
      )}
      {children}
    </header>
  );
}

export default PageHeader;
